import { Area, Block, GeneralAdmission, Seatmap } from '@eventim/seatmap-client';

export class AvailabilityStateMapper {

    public static fromSeatmap(seatmap: Seatmap): boolean {
        return seatmap.areas.some(area => this.fromArea(area));
    }

    private static fromArea(area: Area): boolean {
        return area.blocks.some(block => this.fromBlock(block));
    }

    private static fromBlock(block: Block): boolean {
        let seatAvailability = false;
        let gaAvailability = false;

        if (block.availabilityInfo) {
            seatAvailability = block.availabilityInfo.available > 0;
        }

        if (block.generalAdmissions && block.generalAdmissions.length > 0) {
            gaAvailability = block.generalAdmissions.some(ga => this.fromGeneralAdmission(ga));
        }

        return seatAvailability || gaAvailability;
    }

    private static fromGeneralAdmission(ga: GeneralAdmission): boolean {
        return !!ga.available && ga.available > 0;
    }
}
